import React from 'react'
import classNames from 'classnames'

import { ArrowDirection } from '../contants'
import styles from './PaginationArrowButton.scss'
import PropTypes from 'prop-types'
import { playClickSound, playHoverSound } from 'state/actions/sounds'
import { connect } from 'react-redux'

export class PaginationArrowButton extends React.PureComponent {
    static propTypes = {
        className: PropTypes.string,
        direction: PropTypes.oneOf(Object.values(ArrowDirection)).isRequired,
        isLocked: PropTypes.bool,
        onClick: PropTypes.func.isRequired,
        playHoverSound: PropTypes.func.isRequired,
        playClickSound: PropTypes.func.isRequired,
    }

    handleClick = () => {
        if (!this.props.isLocked) {
            this.props.onClick()
            this.props.playClickSound()
        }
    };

    handleMouseEnter = () => {
        if (!this.props.isLocked) {
            this.props.playHoverSound()
        }
    };

    render() {
        const baseClassName = classNames(
            styles.base,
            this.props.isLocked && styles.base__locked,
            this.props.className,
        )

        const iconClassName = classNames(styles.icon, styles[`icon__${this.props.direction}`])

        return (
            <div className={baseClassName}>
                <div
                    className={iconClassName}
                    onClick={this.handleClick}
                    onMouseEnter={this.handleMouseEnter}
                />
            </div>
        )
    }
}

const mapDispatchToProps = { playHoverSound, playClickSound }

export default connect(null, mapDispatchToProps)(PaginationArrowButton)



// WEBPACK FOOTER //
// ./components/Pagination/PaginationArrowButton/PaginationArrowButton.jsx